<template>
    <div
        @mouseenter="menuOpen = true"
        @mouseleave="menuOpen = false"
        class="h-full flex items-center relative text-left"
    >
        <div
            id="proba"
            class="inline-flex justify-between w-full rounded-md border border-gray-300 dark:border-gray-700 shadow-sm px-4 py-2 bg-white dark:bg-black text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500 cursor-pointer"
            :class="[focus ? 'ring-4 ring-green-500 ring-offset-4' : '']"
        >
            <div v-if="values.length" class="flex space-x-2 overflow-x-hidden">
                <c-badge-x
                    @click.native="$emit('toggleSelection', value)"
                    v-for="value in values"
                    :key="value"
                    :text="value"
                />
            </div>
            <p v-else>{{ placeholder }}</p>

            <ChevronSelectIcon class="-mr-1 sm:ml-2 h-5 w-5" />
        </div>
        <c-dropdown-select
            :open="menuOpen"
            :values="values"
            :list="list"
            :settings="settings"
            @toggleSelection="$emit('toggleSelection', $event)"
            @settings="$emit('settings', $event)"
        />
    </div>
</template>

<script>
import { ChevronSelectIcon } from "@easy/ui/icons";
import cDropdownSelect from "./cDropdownSelect.vue";
import cBadgeX from "./cBadgeX.vue";

export default {
    name: "cMultiSelect",
    components: {
        cDropdownSelect,
        cBadgeX,
        ChevronSelectIcon,
    },
    props: {
        placeholder: String,
        list: Array,
        values: Array,
        focus: Boolean,
        settings: Boolean,
    },
    data() {
        return {
            menuOpen: false,
        };
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("change", value);
            },
        },
    },
};
</script>
